module.exports = __webpack_public_path__ + "media/images/hodzzy-logo-81947ca771e854011f0271faee7189ed.png";